import {updateTooltipData} from './updateTooltipData';
import {enableRooms} from './enableRooms';
import {Lightbox} from '../../classes/Lightbox';
import {updateCriteo} from '../../common/criteo';
import {showTooltip, hideTooltip, setTooltipPosition} from "./tooltip";

export const initSectionChooserParkinChooserStorage = () => {
    const components = document.querySelectorAll(`section.chooser-parking,section.chooser-storage`);

    if (components.length)
    {
        components.forEach((component) => {
            const calc = document.querySelector(`section.calculator-mortgage`);
            const container = component.querySelector(`div > div`);
            const layout = container.querySelector(`svg`);
            const rooms = Array.from(container.querySelectorAll(`ul > li`));
            const tooltip = container.querySelector(`div.tooltip`);
            
            enableRooms(layout, rooms);
			updateCriteo( rooms.map( ( room ) => room.dataset.id ), 'viewList' );
			
			const selectedPlaceClass = 'place-select';
			const selectedLightboxPlaceClass = 'place-lightbox-select';
			
			const breakpoint = 956;
			
			const lightboxCloseCallback = () => {
				const existPlace = layout.querySelector( `.enabled.${selectedPlaceClass}` );
				
				if ( existPlace && window.innerWidth < breakpoint )
				{
					existPlace.classList.remove( selectedPlaceClass );
					existPlace.classList.add( selectedLightboxPlaceClass );
				}
			};
			
			const displayLightbox = ( path ) => {
				const lightboxTooltip = tooltip.cloneNode(true);
				lightboxTooltip.classList.add(`parking-storage-tooltip`);
				lightboxTooltip.classList.remove(`tooltip`);
				updateTooltipData(lightboxTooltip, path, rooms, calc);
				updateTooltipData(tooltip, path, rooms, calc);
				showTooltip(lightboxTooltip);
				Lightbox.open(lightboxTooltip, null, `tooltip`);
				Lightbox.addCloseCallback( lightboxCloseCallback );
			};
			
			const hideExistPlaces = ( place = null, lightboxPlace = null ) => {
				if ( place )
				{
					place.classList.remove( selectedPlaceClass );
				}
				
				if ( lightboxPlace )
				{
					lightboxPlace.classList.remove( selectedLightboxPlaceClass );
				}
			};
			
			component.addEventListener( 'click', ( {target} ) => {
				const existPlace = layout.querySelector( `.enabled.${selectedPlaceClass}` );
				const existLightboxPlace = layout.querySelector( `.enabled.${selectedLightboxPlaceClass}` );
				const path = target.closest( 'svg .enabled' );
				const isTooltip = !!target.closest( 'div.tooltip' );
				
				if (window.innerWidth >= breakpoint)
				{
					if ( !isTooltip )
					{
						if ( path )
						{
							if ( path === existPlace )
							{
								hideExistPlaces( existPlace, existLightboxPlace );
							
								hideTooltip( tooltip );
							}
							else
							{
								hideExistPlaces( existPlace, existLightboxPlace );
								
								path.classList.add( selectedPlaceClass );
								
								updateTooltipData(tooltip, path, rooms, calc);
								setTooltipPosition(container, layout, tooltip, path);
								showTooltip(tooltip);
							}
						}
						else
						{
							hideExistPlaces( existPlace, existLightboxPlace );
							
							hideTooltip( tooltip );
						}
					}
				}
				else
				{
					hideExistPlaces( existPlace, existLightboxPlace );
					
					if ( path )
					{
						path.classList.add( selectedPlaceClass );
						
						displayLightbox( path );
					}
				}
			} );
			
			window.addEventListener( 'resize', () => {
				const existPlace = layout.querySelector( `.enabled.${selectedPlaceClass}` );
				
				if ( existPlace )
				{
					if ( window.innerWidth >= breakpoint )
					{
						setTooltipPosition(container, layout, tooltip, existPlace);
						showTooltip(tooltip);
						
						const lightbox = Lightbox.getLightbox();
						if ( lightbox && lightbox.classList.contains( 'tooltip') )
						{
							lightbox.style.display = 'none';
							Lightbox.close();
						}
					}
					else
					{
						hideTooltip( tooltip );
						
						if ( !Lightbox.getLightbox() )
						{
							displayLightbox( existPlace );
						}
					}
				}
			} );
        });
    }
};
